import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import "./App.css";
import HomeLayout from "@/layouts/HomeLayout";
import ProtectedLayout from "@/layouts/ProtectedLayout/ProtectedLayout";

import RegisterPage from "@/pages/auth/RegisterPage";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import LoginPage from "@/pages/auth/LoginPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";

import DashboardPage from "@/pages/dashboard/DashboardPage";
import UsersPage from "@/pages/dashboard/UsersPage";
import ActivitiesPage from "@/pages/dashboard/ActivitiesPage";
import ActivityFormPage from "@/pages/dashboard/ActivityFormPage";
import FormsPage from "@/pages/dashboard/FormsPage";
import PrestartFormViewPage from "@/pages/dashboard/PrestartFormViewPage";
import PrestartFormFormPage from "@/pages/dashboard/PrestartFormFormPage";
import AllFormsPage from "@/pages/dashboard/AllFormsPage";
import FormDetailsPage from "@/pages/dashboard/FormDetailsPage";
import GuidesPage from "@/pages/dashboard/GuidesPage";
import GuideFormPage from "@/pages/dashboard/GuideFormPage";
import DocumentsPage from "@/pages/dashboard/DocumentsPage";
import DocumentFormPage from "@/pages/dashboard/DocumentFormPage";
import CompaniesPage from "@/pages/dashboard/CompaniesPage";
import CompanyFormPage from "@/pages/dashboard/CompanyFormPage";
import AdminFormPage from "@/pages/dashboard/AdminFormPage";
import ContactsPage from "@/pages/dashboard/ContactsPage";
import ChangePasswordPage from "@/pages/dashboard/ChangePasswordPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import Roles from "@/constants/roles";

import ErrorPage from "@/pages/ErrorPage";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<HomeLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      </Route>

      <Route path="/" element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="activities" element={<ActivitiesPage />} />
        <Route path="activities/add" element={<ActivityFormPage />} />
        <Route path="activities/:id/edit" element={<ActivityFormPage />} />
        <Route path="forms" element={<FormsPage />} />
        <Route
          path="forms/add"
          element={
            <ProtectedRoute allowedRoles={[Roles.SUPER_ADMIN]}>
              <PrestartFormFormPage />
            </ProtectedRoute>
          }
        />
        <Route path="forms/:id" element={<PrestartFormViewPage />} />
        <Route
          path="all-forms"
          element={
            <ProtectedRoute allowedRoles={[Roles.ADMIN]}>
              <AllFormsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="all-forms/:formType/:id"
          element={
            <ProtectedRoute allowedRoles={[Roles.ADMIN]}>
              <FormDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="guides"
          element={
            <ProtectedRoute allowedRoles={[Roles.ADMIN]}>
              <GuidesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="guides/add"
          element={
            <ProtectedRoute allowedRoles={[Roles.ADMIN]}>
              <GuideFormPage />
            </ProtectedRoute>
          }
        />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="documents/add" element={<DocumentFormPage />} />
        <Route path="documents/:id/edit" element={<DocumentFormPage />} />
        <Route
          path="companies"
          element={
            <ProtectedRoute allowedRoles={[Roles.SUPER_ADMIN]}>
              <CompaniesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="companies/add"
          element={
            <ProtectedRoute allowedRoles={[Roles.SUPER_ADMIN]}>
              <CompanyFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="companies/:id/edit"
          element={
            <ProtectedRoute allowedRoles={[Roles.SUPER_ADMIN]}>
              <CompanyFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="companies/invite-admin"
          element={
            <ProtectedRoute allowedRoles={[Roles.SUPER_ADMIN]}>
              <AdminFormPage />
            </ProtectedRoute>
          }
        />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="account/change-password" element={<ChangePasswordPage />} />
      </Route>

      <Route path="*" element={<ErrorPage />} />
    </>
  )
);
